// @flow
import type { SignUpCheckOrderConsistencyActionType } from './actions';

export type SignUpCheckOrderConsistencyStateType = {|
  isOrderOk: boolean,
|};

const initialCheckOrderConsistencyState: SignUpCheckOrderConsistencyStateType = {
  isOrderOk: false,
};

export const signUpCheckOrderConsistencyReducer = (
  state: SignUpCheckOrderConsistencyStateType = initialCheckOrderConsistencyState,
  action: SignUpCheckOrderConsistencyActionType
) => {
  switch (action.type) {
    case 'SIGNUP_SET_CHECK_ORDER_CONSISTENCY_STATUS':
      return {
        ...state,
        isOrderOk: action.payload.status,
      };
    default:
      return state;
  }
};
